export const YYYY_MM_DD = 'YYYY/MM/DD'
export const YYYY_MM_DD_HH_MM = 'YYYY/MM/DD HH:mm'
